import React, { ReactNode } from 'react'
import classNames from 'classnames'

import Loading from './Loading'
import Icon, { IconType } from './Icon'

export const iconSize = {
  large: 24,
  medium: 20,
  small: 16,
}

interface Props {
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  children?: ReactNode

  className?: string
  theme?: 'fill' | 'outline' | 'text' | 'iconOnly'
  size?: 'small' | 'medium' | 'large'
  color?: 'green' | 'black' | 'blue' | 'red'
  fullWidth?: boolean

  iconType?: IconType
  title?: string

  isLoading?: boolean
  disabled?: boolean
  testId?: string
}

export default function Button({
  type = 'button',
  onClick,
  children,
  className,
  theme = 'fill',
  size = 'large',
  color = 'green',
  fullWidth,
  iconType,
  title,
  isLoading = false,
  disabled,
  testId,
}: Props) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames('Button', className, `Button--${size}`, `Button--${theme}`, {
        disabled,
        fullWidth,
        isLoading,
        [color]: theme === 'fill' || theme === 'text',
      })}
      disabled={disabled}
      data-testid={testId}
    >
      <Loading isVisible={isLoading} size={theme === 'text' ? iconSize['small'] : iconSize[size]} />
      {!isLoading && (
        <>
          {iconType && (
            <Icon
              className={classNames('Button__icon', { withText: theme !== 'iconOnly' })}
              name={iconType}
              title={theme === 'iconOnly' ? title || iconType : undefined}
              size={theme === 'iconOnly' && size !== 'small' ? 40 : 24}
            />
          )}
          {theme !== 'iconOnly' && (
            <span role="button" className="Button__text">
              {children || title}
            </span>
          )}
        </>
      )}
    </button>
  )
}
